'use client';
import { useRef, ChangeEvent } from 'react';
import Icon from '@/components/elements/Icon';
import { Icons } from '@/components/elements/Icon/constants';

const CurrencySelect = ({
  value,
  onChange,
}: {
  value: 'ETH' | 'USD';
  onChange: (v: 'ETH' | 'USD') => void;
}) => {
  const selectRef = useRef<HTMLSelectElement>(null);

  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value as 'ETH' | 'USD');
  };

  const handleClick = () => {
    if (selectRef?.current) {
      selectRef.current.classList.remove('opacity-0');
      selectRef.current.focus();
    }
  };

  return (
    <div className="relative inline-flex">
      <select
        ref={selectRef}
        className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
        value={value}
        onChange={handleSelectChange}
      >
        <option value="ETH">{'ETH'}</option>
        <option value="USD">{'USD'}</option>
      </select>
      <button
        type="button"
        className={`rounded-lg h-10 px-2.5 font-medium inline-flex items-center justify-between cursor-pointer text-sm text-gray-800 text-opacity-80 bg-gray-100 border border-gray-300`}
        onClick={handleClick}
      >
        <span className="flex items-center mr-2">{`Price: ${value}`}</span>
        <Icon name={Icons.CHEVRON_DOWN} size={16} className="text-gray-400" />
      </button>
    </div>
  );
};

export default CurrencySelect;
